'use client';

import { brandStyleRule } from '@/lib/brand-style';
import useAppearanceSettings from '@/state/appearance-settings';

// The server component beside it paints the first frame from the request-time
// lookup; this one follows the query, so a refetch on a refocused tab repaints
// a page that is already open. Rendered after it in the tree, which is what
// wins the tie at equal specificity once the two disagree.
export const BrandStyleClient = () => {
  const { data } = useAppearanceSettings();
  if (!data) return null;

  return <style>{brandStyleRule(data.branding)}</style>;
};
